import React from "react"

import { Stack } from "@mui/material"

import { OrderFilterKey } from "../constant"

import { ClearFiltersButton, DateFilter, StatusFilter } from "./filters"
import { FreeSearchFilter } from "./filters/FreeSearchFilter"
import { ProjectFilter } from "./filters/ProjectFilter"

interface OrdersFilterBarProps {
    isFree?: boolean
    clearFiltersButton: boolean
    handleClearFilters: () => void
    selectedProjects: string[]
    setSelectedProjects: (projects: string[]) => void
    handleUpdateParam: (paramName: string, paramValue: string) => void
    handleUpdateDateParams: (startDate: string, endDate: string) => void
}

const OrdersFilterBarComponent: React.FC<OrdersFilterBarProps> = ({
    isFree,
    clearFiltersButton,
    handleClearFilters,
    selectedProjects,
    setSelectedProjects,
    handleUpdateParam,
    handleUpdateDateParams
}) => {
    return (
        <Stack direction="row" gap={1} sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
            {isFree ? (
                <>
                    <DateFilter handleUpdateDateParams={handleUpdateDateParams} />
                    <StatusFilter isFree={isFree} handleUpdateParam={handleUpdateParam} />
                    <FreeSearchFilter label="Transaction ID" filterKey={OrderFilterKey.PUBLISHER_PURCHASE_ID} handleUpdateParam={handleUpdateParam} />
                    <FreeSearchFilter label="Player ID" filterKey={OrderFilterKey.PLAYER_ID} handleUpdateParam={handleUpdateParam} />
                    <FreeSearchFilter label="Order ID" filterKey={OrderFilterKey.ORDER_ID} handleUpdateParam={handleUpdateParam} />
                </>
            ) : (
                // Paid Orders filters
                <>
                    <ProjectFilter
                        selectedProjects={selectedProjects}
                        setSelectedProjects={setSelectedProjects}
                        dataTestId="projectFilter"
                    />
                    <DateFilter handleUpdateDateParams={handleUpdateDateParams} />
                    <FreeSearchFilter label="Player ID" filterKey={OrderFilterKey.PLAYER_ID} handleUpdateParam={handleUpdateParam} />
                    <FreeSearchFilter label="Order ID" filterKey={OrderFilterKey.ORDER_ID} handleUpdateParam={handleUpdateParam} />
                    <FreeSearchFilter label="Subscription ID" filterKey={OrderFilterKey.SUBSCRIPTION_ID} handleUpdateParam={handleUpdateParam} />
                    <FreeSearchFilter label="Transaction ID" filterKey={OrderFilterKey.PUBLISHER_PURCHASE_ID} handleUpdateParam={handleUpdateParam} />
                    <StatusFilter isFree={isFree} handleUpdateParam={handleUpdateParam} />
                </>
            )}
            {clearFiltersButton && (
                <ClearFiltersButton onClick={handleClearFilters} />
            )}
        </Stack>
    )
}

export const OrdersFilterBar = React.memo(OrdersFilterBarComponent)

OrdersFilterBar.displayName = 'OrdersFilterBar'
